export default {
    props: {
        rangeStart: {
            type: Date,
            default: undefined,
            kComposite: 'range.start'
        }, 
        rangeEnd: {
            type: Date,
            default: undefined,
            kComposite: 'range.end'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-gantt-vue-wrapper/src/KendoGantt/Range.js